import React, { Component } from 'react';
import logo from './logo.svg';
import styles from './App.css';
import com from './common.css';

import Header from './Header.js';
import Profile from './Profile.js';
import Techs from './Techs.js';
import History from './History.js';
import Appeal from './Appeal.js';

class App extends Component {

  render(){
    return pug`
      div(className=styles.App)
        
        Header

        div(className=com.content)

          h2(id="profile") プロフィール

          Profile
            
          h2(id="tech") 技術

          Techs

          h2(id="history") 職歴/実績

          History

          h2(id="appeal") アピール 
          Appeal

          //h2(id="ninpro") 忍者プログラマーとは
          //p 忍者プログラマーとは一体何なのか？
          
    `;
  }
}



export default App;



// WEBPACK FOOTER //
// ./src/App.js